import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d867bec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "baged-filter"
}

import { ref, computed, watch } from "vue";

import { useRouter } from "vue-router";

import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";
import SearchInput from "@/shared/forms/SearchInput.vue";
import Button from "primevue/button";
import ArchiveButton from "@/shared/buttons/ArchiveButton.vue";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";
import Badge from "primevue/badge";

interface BreadCrumbItem {
  label: string;
  archive: string;
  route?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TopListEntitiesPanel',
  props: {
    isArchiveEnabled: { type: Boolean },
    isFilterEnabled: { type: Boolean },
    isFilterSetted: { type: Boolean },
    searchPlaceholder: {},
    buttonLabel: {},
    routeCreate: {},
    items: {},
    disabledArchive: { type: Boolean },
    disabledFilter: { type: Boolean },
    isButtonDisabled: { type: Boolean }
  },
  emits: [
  "setCommonFilter",
  "toggleArchive",
  "toggleFilter",
  "createAction",
],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const searchField = ref(null);
const debounceTimeout = ref(0);

const sendItemRequest = () => {
  emit("setCommonFilter", searchField.value);
};

watch(
  () => searchField.value,
  () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(sendItemRequest, 400);
  },
  { immediate: true }
);

const router = useRouter();

const filteredItems = computed(() => {
  return props.items.filter((item) =>
    props.isArchiveEnabled
      ? ["both", "archive"].includes(item.archive)
      : ["both", "no_archive"].includes(item.archive)
  );
});

const createEntity = (event: any) => {
  if (props.routeCreate.length > 0)
    router.push({
      name: props.routeCreate,
    });
  else emit("createAction", event);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TopPanel, null, {
    default: _withCtx(() => [
      _createVNode(BreadCrumbs, { items: filteredItems.value }, null, 8, ["items"]),
      _createVNode(SearchInput, {
        placeholder: _ctx.searchPlaceholder,
        class: "search-input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (searchField.value = $event)),
        modelValue: searchField.value
      }, null, 8, ["placeholder", "modelValue"]),
      (!_ctx.disabledFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Button), {
              icon: "pi pi-filter-fill",
              id: "filter-button",
              severity: "secondary",
              "aria-label": "Bookmark",
              class: _normalizeClass(["m-l-12 f-s-0 toggled", [_ctx.isFilterEnabled ? 'filter-enabled' : '']]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('toggleFilter')))
            }, null, 8, ["class"]),
            (_ctx.isFilterSetted)
              ? (_openBlock(), _createBlock(_unref(Badge), {
                  key: 0,
                  class: "bage"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.disabledArchive)
        ? (_openBlock(), _createBlock(ArchiveButton, {
            key: 1,
            class: _normalizeClass(["m-l-12 f-s-0", [_ctx.isArchiveEnabled ? 'archive-enabled' : '']]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('toggleArchive')))
          }, null, 8, ["class"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Button), {
        disabled: _ctx.isButtonDisabled,
        label: _ctx.buttonLabel,
        class: "entity-create-button m-l-16 m-r-16",
        onClick: createEntity
      }, null, 8, ["disabled", "label"])
    ]),
    _: 1
  }))
}
}

})